import { cn } from '../../lib/utils.js';
import type { HTMLAttributes } from 'react';

interface BadgeProps extends HTMLAttributes<HTMLSpanElement> {
  variant?: 'default' | 'outline';
}

export function Badge({ className, variant = 'default', children, ...props }: BadgeProps): JSX.Element {
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1 rounded-md px-2 py-0.5 text-xs font-medium border',
        variant === 'default' && 'bg-muted text-foreground border-border',
        className,
      )}
      {...props}
    >
      {children}
    </span>
  );
}
